import { defineStore } from 'pinia'
import usersServices from '@/api/services/usersServices.js'
import { useAuthStore } from '@/stores/authStore.js'
import { ref, reactive } from 'vue'

export const useUserStore = defineStore('userStore', () => {
  const initialized = ref(false)
  const user = reactive({
    id: '',
    type: '',
    email: '',
    enabled: true,
    firstName: '',
    language: '',
    lastName: '',
    nickName: '',
    avatar: ''
  })

  const user_language_info = ref(null)

  const saveUserData = (userPayload) => {
    Object.assign(user, {
      id: userPayload.id,
      email: userPayload.email,
      firstName: userPayload.firstName,
      language: userPayload.language,
      lastName: userPayload.lastName,
      nickName: userPayload.nickName,
      subscribed: userPayload.subscribed,
      avatar: userPayload.avatar
    })
  }

  const getUserData = async (force = false) => {
    if (initialized.value && !force) {
      return true
    }

    initialized.value = true

    const authStore = useAuthStore()

    const { data } = await usersServices.me(authStore.authData.token)

    if (!data) return

    saveUserData(data)
  }

  const uploadImage = async (selectedFile) => {
    try {
      const authStore = useAuthStore()
      const fd = new FormData()
      fd.append('profile_picture', selectedFile, selectedFile.name)

      await usersServices.updateProfilePicture({
        token: authStore.authData.token,
        userId: user.id,
        file: fd
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  const editProfile = async ({ selectedFile, profilePayload }) => {
    const authStore = useAuthStore()
    return {
      resultEditProfile:
        profilePayload &&
        (await usersServices.editProfile({
          token: authStore.authData.token,
          profilePayload: {
            firstName: profilePayload.firstName,
            language: profilePayload.language,
            lastName: profilePayload.lastName,
            nickName: profilePayload.nickName,
            subscribed: profilePayload.subscribed
          }
        })),
      resultUploadingImage: selectedFile && (await uploadImage(selectedFile)),
      resultGetUserData:
        (profilePayload || selectedFile) && (await getUserData(true))
    }
  }

  const changePassword = async (payload) => {
    const authStore = useAuthStore()
    return await usersServices.setNewPassword({
      token: authStore.authData.token,
      payload
    })
  }

  return {
    initialized,
    user,
    user_language_info,

    saveUserData,
    getUserData,
    uploadImage,
    editProfile,
    changePassword
  }
})
